import React from 'react';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import { Link } from '@/navigation';
import type { SearchedDoctors } from '@/entities/doctor/model/types';
interface Props {
  doctors: SearchedDoctors[];
  cityAlias: string;
  setLoadNewPage: (value: boolean) => void;
}
export const DoctorsList: React.FC<Props> = ({
  doctors,
  cityAlias,
  setLoadNewPage
}) => {
  const t = useTranslations('shared.header');
  const getDoctorFullName = (doctor: SearchedDoctors) => {
    return `${doctor.lastname || ''} ${doctor.firstname || ''} ${doctor.patronymic || ''}`;
  };
  return <section data-sentry-component="DoctorsList" data-sentry-source-file="DoctorsList.tsx">
      <p className="my-2 px-2 text-sm text-textSecondary">{t('doctors')}</p>

      <div className="flex flex-col gap-2">
        {doctors.map(doctor => <Link href={`/${cityAlias}/doctor/${doctor.alias}`} key={doctor.id} className="group flex max-h-[46px] items-center gap-3 rounded-lg p-2 py-4 transition-all duration-200 ease-in-out hover:bg-gray-50 active:bg-gray-100" onClick={() => setLoadNewPage(true)}>
            <div>
              <Image src={doctor.avatar ? `/${doctor.avatar}` : 'https://idoctor.kz/images/no-userpic.gif'} alt={`Фотография профиля врача ${getDoctorFullName(doctor)}`} width={32} height={32} className="max-size-8 size-8 rounded-full object-cover" />
            </div>
            <div className="min-w-0 flex-1">
              <p className="max-w-[80ch] truncate text-sm text-black">{getDoctorFullName(doctor)}</p>
              <p className="text-xs text-textSecondary">
                {t('searchResults.work_experience', {
              count: doctor.workExperience
            })}
              </p>
            </div>
          </Link>)}
      </div>
    </section>;
};